import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "defaultButton" }

import { ref } from 'vue';
import type { PropType } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'mainButton',
  props: {
    onClick: {
        type: Function as PropType<() => void>,
        required: false
    },
    title: {
        type: String,
        default: () => ''
    },
    activeStatus: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_button, {
      disabled: !props.activeStatus,
      onClick: props.onClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}
}

})